import { useEffect, useState } from 'react'

// Громкость собственного голоса до входа в звонок: человек видит, что его
// слышно, и не выясняет это уже в комнате. Свой захват, а не трек комнаты, —
// prejoin к SFU ещё не подключён.
export function useMicLevel(enabled: boolean, deviceId: string | undefined): number {
  const [level, setLevel] = useState(0)

  useEffect(() => {
    if (!enabled || typeof AudioContext === 'undefined') return
    let cancelled = false
    let raf = 0
    let stream: MediaStream | null = null
    let ctx: AudioContext | null = null

    async function start() {
      try {
        stream = await navigator.mediaDevices.getUserMedia({
          audio: deviceId ? { deviceId } : true,
        })
      } catch {
        // Микрофон занят или запрещён — отказ уже показан пробой устройств,
        // индикатор просто остаётся пустым.
        return
      }
      if (cancelled) {
        for (const track of stream.getTracks()) track.stop()
        return
      }
      ctx = new AudioContext()
      const analyser = ctx.createAnalyser()
      analyser.fftSize = 1024
      ctx.createMediaStreamSource(stream).connect(analyser)
      const samples = new Float32Array(analyser.fftSize)

      const tick = () => {
        analyser.getFloatTimeDomainData(samples)
        let sum = 0
        for (const sample of samples) sum += sample * sample
        const rms = Math.sqrt(sum / samples.length)
        // Речь живёт в нижней части линейной шкалы — корень растягивает её так,
        // чтобы полоска реагировала на обычный разговор, а не только на крик.
        setLevel(Math.min(1, Math.sqrt(rms) * 2.2))
        raf = requestAnimationFrame(tick)
      }
      tick()
    }

    void start()
    return () => {
      cancelled = true
      if (raf) cancelAnimationFrame(raf)
      if (stream) for (const track of stream.getTracks()) track.stop()
      void ctx?.close().catch(() => {})
      setLevel(0)
    }
  }, [enabled, deviceId])

  // Выключенный микрофон — всегда пустая шкала, чем бы ни закончился последний
  // замер до выключения.
  return enabled ? level : 0
}
